import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-pick-action',
  templateUrl: './pick-action.component.html',
  styleUrls: ['./pick-action.component.scss'],
})
export class PickActionComponent implements OnInit {
  config = {
    type: '',
    pageType: 'EXTERNAL',
    value: '',
    data: null
  };
  @Input() actions = [
    {key: 'USSD', label: 'Ussd', valueLabel: 'Entrez le code ussd'},
    {key: 'IPP', label: 'Ipp', valueLabel: 'Entrez le code IPP'},
    {key: 'PAGE', label: 'Page', valueLabel: 'Entrez l\'adresse du lien'},
  ];
  @Input() showInput = false;
  internalLinks = [
    {label: 'Achat pass', deeplink: '/telco/buy-voice-data/pass-mixel'}
  ];
  btnText;
  constructor(private fb: FormBuilder,
    public modalController: ModalController,
    private common: CommonService,
    ) { }

  ngOnInit() {
    this.loadConfigs();
  }

  async loadConfigs() {
    try {
      const res: any = await this.common.appDeepLinks().toPromise();
      if (!res || !res.length) {
        return;
      }
      this.internalLinks = JSON.parse(res[0].value);
    } catch (error) {
    }
  }
  dismiss(data?) {
    this.modalController.dismiss(data);
  }
  changeLayout() {

  }
  save() {
    let value = '';
    this.config.type = this.config.data.key;
    if (this.config.type === 'PAGE') {
      value = this.config.type + ':' + (this.config.pageType || 'EXTERNAL') + ':' + encodeURIComponent(this.config.value);
    } else {
      value = this.config.type + ':' + this.config.value;
    }
    console.log('Value: ', value);
    this.dismiss({
      result: value,
      actionText: 'actionText:' + this.btnText,
    });
  }

  get readOnly() {
    return this.config.pageType === 'INTERNAL' && this.internalLinks.length;
  }
}
